// import logo from './logo.svg';
import './App.css';
import MainGame from './pages/MainGame';

function App() {
  return (
    <>
      <MainGame />
    </>
  );
}

export default App;
